import React, { useEffect, useState } from "react";
import axios from "axios";
import { X } from "lucide-react";
import ApiList from "./NextForm";
import envConfig from "../../config/config";

const getMethodColor = (method) => {
    switch (method?.toUpperCase()) {
        case "GET":
            return "text-green-600";
        case "POST":
            return "text-blue-600";
        case "PUT":
            return "text-yellow-600";
        case "DELETE":
            return "text-red-600";
        case "PATCH":
            return "text-purple-600";
        default:
            return "text-gray-600";
    }
};

const ViewDetails = ({
    swaggerFileId,
    projectId,
    projectStatus,
    setShowApiModal,
    onClose,
}) => {
    console.log("ProjectSTatus", projectStatus)
    const [apiData, setApiData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState("");
    const [showApiListModal, setShowApiListModal] = useState(false);

    useEffect(() => {
        if (!swaggerFileId) {
            alert("No swaggerFileId provided");
            return;
        }

        const fetchApiList = async () => {

            try {
                const res = await axios.get(
                    `${envConfig.REACT_APP_APIREPO_WRITE}/apirepo/v0.1/apisSwagger/${swaggerFileId}`
                );
                if (res.data?.apis?.length) {
                    const enrichedData = res.data.apis?.map((api) => ({
                        ...api,
                        apiName: api.apiName || "",
                        description: api.description || "",
                        category: api.category || "",
                        vertical: api.vertical || "",
                        url: api.url || "",
                        method: api.method || "",
                    }));
                    setApiData(enrichedData);
                } else {
                    alert("No APIs found for this swagger file.");
                }
            } catch (err) {
                console.error("Failed to fetch APIs:", err);
                setErrorMsg("Failed to fetch API data.");
            } finally {
                setLoading(false);
            }
        };

        fetchApiList();
    }, [swaggerFileId]);

    return (
        <div className="max-w-7xl mx-auto px-4 py-4">
            <div className="flex justify-between">
                <h2 className="text-2xl font-bold mb-4">API Details</h2>
                <button
                    className="text-xl font-bold text-gray-500 hover:text-gray-700"
                    onClick={() => setShowApiModal(false)}
                >
                    <X className="w-8 h-8" />
                </button>
            </div>

            {errorMsg && (
                <div className="mb-4 text-red-600 font-semibold bg-red-100 p-2 rounded">
                    {errorMsg}
                </div>
            )}

            {loading ? (
                <p>Loading APIs...</p>
            ) : (
                <div>
                    <div className="overflow-x-auto shadow rounded-lg border border-gray-200 max-h-[400px]">
                        <table className="min-w-full bg-white text-sm text-left">
                            <thead className="bg-gray-100 sticky top-0 z-10">
                                <tr>
                                    <th className="p-3">URL</th>
                                    <th className="p-3">Method</th>
                                    <th className="p-3">API Name</th>
                                    <th className="p-3">Description</th>
                                    <th className="p-3">Vertical</th>
                                    <th className="p-3">API Category</th>
                                    <th className="p-3">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {apiData?.map((api) => (
                                    <tr key={api.apiId} className="border-t">
                                        <td className="p-3 font-mono text-blue-600">{api.url}</td>
                                        <td className={`p-3 uppercase font-semibold ${getMethodColor(api.method)}`}>
                                            {api.method}
                                        </td>
                                        <td className="p-3">{api.apiName}</td>
                                        <td className="p-3">{api.description}</td>
                                        <td className="p-3">{api.vertical}</td>
                                        <td className="p-3">{api.tag}</td>
                                        <td className="p-3 text-center">
                                            {api.apiName && api.description && api.vertical && api.tag ? (
                                                <span className="text-green-500">✔</span>
                                            ) : (
                                                <span className="text-red-500">✘</span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {/* Action Buttons */}
            <div className="mt-6 flex justify-end gap-3">
                {projectStatus === "incomplete" && (
                    <button
                        onClick={() => setShowApiListModal(true)}
                        className="px-6 py-2 rounded bg-blue-600 text-white font-medium"
                    >
                        Edit
                    </button>
                )}
                <button
                    onClick={onClose}
                    className="px-6 py-2 rounded bg-gray-600 text-white font-medium"
                >
                    Close
                </button>
            </div>

            {/* Conditional ApiList Modal */}
            {showApiListModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-[95%] max-w-6xl max-h-[90vh] overflow-y-auto">
                        <ApiList
                            swaggerFileId={swaggerFileId}
                            projectId={projectId}
                            setShowApiListModal={setShowApiListModal}
                            onClose={onClose}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ViewDetails;
